import { useState, useEffect } from "react";
import { APP_SERVICES_URL } from "../Constant/constant";
import userSession from "../Constant/auth";

const useSenapiVehiclesInfo = () => {
  const [colors, setColors] = useState([]);
  const [models, setModels] = useState([]);
  const [shapes, setShapes] = useState([]);
  const { CustID, authHeader } = userSession;
  useEffect(() => {
    const fetchVehiclesInfo = async () => {
      try {

        const url = `${APP_SERVICES_URL}/senapi/${CustID}/vehiclesInfo`;

        const response = await fetch(url, {
          method: "GET",
          headers: {
            Authorization: authHeader,
          },
        });

        if (!response.ok) {
          throw new Error("Failed to fetch vehicles information.");
        }

        const data = await response.json();
        setColors(data.colors);
        setModels(data.models);
        setShapes(data.shapes);
      } catch (error) {
        console.error("Error fetching vehicles information:", error);
      }
    };

    fetchVehiclesInfo();
    // eslint-disable-next-line
  }, []);

  return { colors, models, shapes };
};

export default useSenapiVehiclesInfo;